<template>
  <div class="m-card-imgs">
    <ul :class="imgsClassName">
      <li v-for="(img, i) in imgs" class="m-card-img-wrapper" v-if="i<=2" @click="showSwipe(i)">
        <!--<img :src="img.src">-->
        <sq-img :src="img.src"></sq-img>
      </li>
      <span class="m-card-imgs-count fz11" v-if="imgs.length > 3">{{imgs.length}}张</span>
    </ul>
  </div>
</template>

<script>
import preload from '@/assets/images/preload.png'
import SqImage from '@/components/img/adaptImg'
export default {
  components: {
    'sq-img': SqImage
  },
  data () {
    return {
      preload
    }
  },

  props: {
    imgs: {
      type: Array
    }
  },

  computed: {
    imgsClassName () {
      let count = 1
      if (this.imgs.length >= 2) {
        count = 3
      } else {
        count = this.imgs.length
      }
      return `m-card-imgs--${count}`
    }
  },

  methods: {
    showSwipe (index) {
      this.$store.dispatch('initSwipe', {imgs: this.imgs, index})
    }
  }
}
</script>



// WEBPACK FOOTER //
// cardImages.vue?a9d48254